// Bloqueia a app em modo retrato (vertical).
//
// - O manifest já declara `orientation: portrait` (PWA instalada no Android).
// - Aqui reforçamos com a Screen Orientation API quando disponível (Android/
//   Chrome em standalone/fullscreen). Em iOS esta API não existe e o sistema
//   ignora a orientação do manifest — não há forma fiável de a bloquear na web,
//   por isso o melhor esforço é este (falha em silêncio onde não é suportado).

type LockableOrientation = ScreenOrientation & {
  lock?: (orientation: 'portrait' | 'portrait-primary') => Promise<void>;
};

export function lockPortrait(): void {
  try {
    const orientation = (screen.orientation as LockableOrientation | undefined) ?? undefined;
    if (orientation && typeof orientation.lock === 'function') {
      orientation.lock('portrait').catch(() => {
        /* alguns browsers só permitem em fullscreen — ignora */
      });
    }
  } catch {
    /* API indisponível — ignora */
  }
}
